import React, { Component } from "react";
import FaMapMarker from "react-icons/lib/fa/map-marker";
import axios from "axios";
import "regenerator-runtime/runtime";

export default class EventVenue extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  transformVenue = async () => {
    const { venueId } = this.props;
    const venue = await this.getVenue(venueId);
    // this.setState({ venue });
    return venue;
  };

  getDerivedStateFromProps(nextProps) {
    const { venueId } = this.props;
    return this.transformVenue();
  }

  getVenue = venueId => {
    return axios
      .get(
        `https://www.eventbriteapi.com/v3/venues/${venueId}/?token=SZPKTX6HTE6HDIWIMFNP`
      )
      .then(response => {
        return response.data;
      });
  };

  render() {
    const { venue } = this.state;
    if (!venue) {
      return <div />;
    }
    return (
      <div style={{ marginTop: "1em" }}>
        <FaMapMarker style={{ color: "#f77f00" }} />
        {venue.name}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/events/eventVenue.js